module.exports = "<span [class.covance-expired-age]=\"isExpired\">{{value}}</span>"